import { Stack } from '@mui/material';
import { isInsufficientFundsPayment, isMintingStagePayment, isPendingPayment } from 'entities/payment';
import { CancelOrderButton } from 'features/payment-actions';
import { TokenAvatar } from 'shared';
import { withAwaitingPaymentResolve } from 'widgets/buy-package/lib';
import { usePendingPayment } from 'widgets/buy-package/models';

import {
  BackgroundCard,
  EOAInfo,
  EOAWarning,
  InsufficientFundsWarning,
  MintingHint,
  PaymentCountdown,
  PaymentTokenAmount,
} from '../../shared';

const PaymentAwaitingCrypto = () => {
  const { paymentToken, payment, onExpired } = usePendingPayment();

  if (!payment || !paymentToken) return null;

  const isMintingStage = isMintingStagePayment(payment);

  return (
    <BackgroundCard title={isMintingStage ? 'Minting' : 'Expecting Payment'}>
      <Stack alignItems="center" width="100%" spacing={2} mb={2.5}>
        <TokenAvatar
          size={70}
          tokenImg={paymentToken.image}
          tokenName={paymentToken.name}
          networkName={paymentToken.tokenNetworkName}
          networkImg={paymentToken.tokenNetworkImage}
        />
        {!isMintingStage && (
          <PaymentTokenAmount
            tokenSymbol={paymentToken.symbol}
            networkName={paymentToken.tokenNetworkShortName}
            amount={payment.payload.amountToPay}
            maxDecimalDigits={paymentToken.decimals}
            decimals={paymentToken.decimals}
            symbol={paymentToken.symbol}
          />
        )}
      </Stack>

      <EOAInfo
        packageName={payment.payload.packageName}
        network={paymentToken.tokenNetworkName}
        tokenSymbol={paymentToken.symbol}
        tokenAmount={payment.payload.amountToPay}
        tokenDecimals={paymentToken.decimals}
        paymentAddress={payment.payload.wallet}
        isConfirmed
        showEoaHint={!isMintingStage}
      />

      <EOAWarning sx={{ mb: 2 }} />

      {isMintingStage && <MintingHint />}

      {!isMintingStage && <PaymentCountdown onTimeout={onExpired} endTime={payment.payload.expiresAt * 1000} mb={2} />}

      {isPendingPayment(payment) && <CancelOrderButton id={payment.payload.requestId} />}
      {isInsufficientFundsPayment(payment) && (
        <InsufficientFundsWarning
          symbol={paymentToken.symbol}
          cost={payment.payload.initialPackagePrice}
          depositedAmount={payment.payload.currentBalance}
          decimals={paymentToken.decimals}
        />
      )}
    </BackgroundCard>
  );
};

export const PaymentAwaitingCryptoView = withAwaitingPaymentResolve(PaymentAwaitingCrypto);
